import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

const SEM_COMPOSICAO = 'SEM_COMPOSICAO';

export default class FiltroComposicao extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Composição';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        if (!registro.composicao || registro.composicao.length === 0) {
            return SEM_COMPOSICAO;
        }

        let composicao = registro.composicao.filter((comp) => comp.magistrado.sigla).slice();

        composicao = composicao.sort((c1, c2) => {
            if (c1.magistrado.presidenteSessao) {
                return -1;
            }

            if (c2.magistrado.presidenteSessao) {
                return 1;
            }

            if (c1.magistrado.sigla.trim() > c2.magistrado.sigla.trim()) {
                return -1;
            }

            if (c1.magistrado.sigla.trim() < c2.magistrado.sigla.trim()) {
                return 1;
            }

            return 0;
        });

        composicao = composicao.map((comp) => {
            let descricao = comp.magistrado.sigla.trim();

            if (comp.magistrado.presidenteSessao) {
                descricao += ' (P)';
            }

            if (comp.magistrado.ausente) {
                descricao += ' (A)';
            }

            return descricao;
        });

        return composicao.join('||');
    }

    getDescricao(valor) {
        if (valor === SEM_COMPOSICAO) {
            return 'Não definida';
        }

        return valor.split('||').join(', ');
    }
}
